import React from 'react'
import { Avatar } from 'antd'
import { useDocumentUrl } from '../hooks/useDocumentUrl'

interface DocumentAvatarProps extends React.ComponentProps<typeof Avatar> {
    documentId?: string | null
    fallback?: React.ReactNode
}

export const DocumentAvatar: React.FC<DocumentAvatarProps> = ({ documentId, fallback, ...props }) => {
    const { data: url, isLoading } = useDocumentUrl(documentId)

    if (!documentId) {
        return fallback ? <>{fallback}</> : <Avatar {...props} />
    }

    if (isLoading) {
        // You could render a skeleton or loading state here
        return fallback ? <>{fallback}</> : <Avatar {...props} />
    }

    if (!url) {
        return fallback ? <>{fallback}</> : <Avatar {...props} />
    }

    return <Avatar src={url} {...props} />
}
